import React from 'react';

const Reply = ({ className, fill }) => {
  return (
<svg version="1.0" className={className} xmlns="http://www.w3.org/2000/svg"
 width="512.000000pt" height="512.000000pt" viewBox="0 0 512.000000 512.000000"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
fill="orangered" stroke="none">
<path d="M2125 3651 c-16 -10 -267 -249 -557 -529 -402 -391 -528 -518 -533
-542 -15 -68 -9 -75 546 -601 291 -277 539 -509 552 -516 51 -28 125 -5 152
47 12 24 15 79 15 318 l0 290 23 6 c72 19 294 28 425 17 455 -39 759 -168
1069 -455 99 -92 105 -96 148 -96 38 0 52 6 83 34 l37 35 -2 128 c-5 312 -100
609 -255 792 -178 213 -504 357 -938 416 -63 9 -222 18 -352 22 l-238 6 0 279
c0 307 -3 323 -60 353 -39 20 -79 19 -115 -4z"/>
</g>
</svg>
 )
}
export default Reply;